import React, { useEffect, useState, useRef } from "react"
import { CSSTransition } from 'react-transition-group';

export default props => {
  const [orderDetail, setOrderDetail] = useState({})
  const [quantity, setQuantity] = useState(0)
  const [active, setActive] = useState(false)
  const [displayQuantityLimitMessage, setDisplayQuantityLimitMessage] = useState(false)
  const [increaseDisabled, setIncreaseDisabled] = useState(false)
  const [productIsOutOfStock, setProductIsOutOfStock] = useState(false)
  const [maxPerOrder, setMaxPerOrder] = useState(props.maxQuantityPerOrder)
  const [stockQuantity, setStockQuantity] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [isWineNameLong, setIsWineNameLong] = useState(false)
  const [isWineNameLongCondensed, setIsWineNameLongCondensed] = useState(false)
  const [isVarietalBreakdownLong, setIsVarietalBreakdownLong] = useState(false)
  const [isVarietalBreakdownLongCondensed, setIsVarietalBreakdownLongCondensed] = useState(false)
  const wineNameRef = useRef(null)
  const wineNameCondensedRef = useRef(null)
  const varietalBreakdownRef = useRef(null)
  const varietalBreakdownCondensedRef = useRef(null)
  const isPosUser = props.isPosUser || false

  useEffect(() => {
    if (wineNameRef.current) {
      const isOverflowing = wineNameRef.current.scrollWidth > wineNameRef.current.clientWidth
      setIsWineNameLong(isOverflowing)
    }
  }, [props.wineName])

  useEffect(() => {
    if (wineNameCondensedRef.current) {
      const isOverflowing = wineNameCondensedRef.current.scrollWidth > wineNameCondensedRef.current.clientWidth
      setIsWineNameLongCondensed(isOverflowing)
    }
  }, [props.wineName, active])

  useEffect(() => {
    if (varietalBreakdownRef.current) {
      const isOverflowing = varietalBreakdownRef.current.scrollWidth > varietalBreakdownRef.current.clientWidth
      setIsVarietalBreakdownLong(isOverflowing)
    }
  }, [props.varietalBreakdown])

  useEffect(() => {
    if (varietalBreakdownCondensedRef.current) {
      const isOverflowing = varietalBreakdownCondensedRef.current.scrollWidth > varietalBreakdownCondensedRef.current.clientWidth
      setIsVarietalBreakdownLongCondensed(isOverflowing)
    }
  }, [props.varietalBreakdown, active])

  const addButtonClass = isPosUser ? "btn btn-block btn-black btn-lg text-uppercase" : "btn btn-block btn-black btn-lg text-uppercase"
  const transitionClassName = isPosUser ? "d-flex align-items-end flex-column product-card-transition card-body justify-content-center" : "d-flex align-items-end flex-column product-card-transition card-body"
  useEffect(() => {
    document.addEventListener('orderUpdated', (e) => {
      let listItem = e.detail.order.orderDetails.find((orderDetail) => orderDetail.productId == props.id);

      if (listItem == undefined) {
        setActive(false)

        return
      }
      setOrderDetail(listItem || {})

      setMaxPerOrder(listItem.initialMaxQuantityPerOrder || props.maxQuantityPerOrder)
      setStockQuantity(listItem.inventoryQuantityInStock)

      if (listItem.inventoryQuantityInStock <= 0 || listItem.quantity == maxPerOrder) { setIncreaseDisabled(true)}

      if (listItem) {
        setQuantity(listItem.quantity)
        setActive(true)
      } else {
        setQuantity(0)
        setActive(false)
      }
      if (maxPerOrder < stockQuantity) {
        setProductIsOutOfStock(true)
      } else {
        setProductIsOutOfStock(false)
      }
    });
  }, []);

  useEffect(() => {
    let display = props.maxQuantityPerOrder - quantity < 30;
    setDisplayQuantityLimitMessage(displayQuantityLimitMessage || display)
  }, [quantity])

  const increaseQuantity = (e) => {
    e.preventDefault();
    ((quantity + 1) >= maxPerOrder || (stockQuantity - 1 <= 0)) ? setIncreaseDisabled(true) :  setIncreaseDisabled(false)
    if (increaseDisabled === true) { return }

    updateQuantity(quantity + 1);
    setQuantity(quantity + 1)
  }

  const decreaseQuantity = (e) => {
    e.preventDefault();
    (quantity - 1) >= maxPerOrder ? setIncreaseDisabled(true) :  setIncreaseDisabled(false)
    updateQuantity(quantity - 1)
  }

  const updateQuantity = (value) => {
    if  (value > maxPerOrder) {
      setQuantity(maxPerOrder)
      setIncreaseDisabled(true)
      return
    }
    setQuantity(value);
    props.handleAddToCart(props.id, value, props.currentOrderId)
  }

  const handleQuantityOnBlur = (e) => {
    if (quantity.toString().length == 0) {
      setQuantity(orderDetail.quantity)
    }
  }

    const handleShowModal = () => {
      setShowModal(true)
    }

    const handleCloseModal = () => {
      setShowModal(false)
    }

  const productInfoFull = () => (
    <div className="container-fluid">
      {(props.itemType != "foodTable") && (
        <div className="row">
          <div className="col-12">
            <div className="product-image">
              {props.image && (
                <img src={props.image} className="img-fluid" />
              )}
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <div className="product-name">
            {props.vintageYear}
          </div>
          <div className={`product-name ${isWineNameLong ? 'scrolling-text' : 'normal-text'}`} ref={wineNameRef} title={props.wineName}>
            {isWineNameLong ? <span>{props.wineName}</span> : props.wineName}
          </div>
          <div className={`product-name ${isVarietalBreakdownLong ? 'scrolling-text' : 'normal-text'}`} ref={varietalBreakdownRef} title={props.varietalBreakdown}>
            {props.varietalBreakdown ? (isVarietalBreakdownLong ? <span>{props.varietalBreakdown}</span> : props.varietalBreakdown) : (<div className="varietal-breakdown"></div>)}
          </div>
          <div className="product-name">
            {props.size}
          </div>
          <div className="mt-2 d-flex justify-content-center align-self-stretch product-info-section">
            {props.productInformation && props.productInformation.trim() !== '' && (
              <span 
                className="product-info-link"
                onClick={handleShowModal}
              >
                Product Information
              </span>
            )}
          </div>
          <div className="price">
            {props.price}
          </div>
          <div className="vertical-placeholder"></div>
        </div>
      </div>
    </div>
  )

  const productInfoCondensed = () => {
    return (
      <div className="container-fluid">
        <div className="row no-gutters">
          {(props.itemType != "foodTable") && (
            <div className="col-12">
              <div className="product-image">
                {props.image && (
                  <img src={props.image} className="img-fluid" />
                )}
              </div>
            </div>
          )}
          <div className={(props.itemType == "foodTable") && "col-12" || "col-12"}>
            <div className="name-wrapper">
              <div className={isPosUser ? "product-name-pos" : "product-name"}>
                {props.vintageYear}
              </div>
              <div className={`${isPosUser ? "product-name-pos" : "product-name"} ${isWineNameLongCondensed ? 'scrolling-text' : 'normal-text'}`} ref={wineNameCondensedRef} title={props.wineName}>
                {isWineNameLongCondensed ? <span>{props.wineName}</span> : props.wineName}
              </div>
              <div className={`${isPosUser ? "product-name-pos" : "product-name"} ${isVarietalBreakdownLongCondensed ? 'scrolling-text' : 'normal-text'}`} ref={varietalBreakdownCondensedRef} title={props.varietalBreakdown}>
                {props.varietalBreakdown ? (isVarietalBreakdownLongCondensed ? <span>{props.varietalBreakdown}</span> : props.varietalBreakdown) : (<div className="varietal-breakdown"></div>)}
              </div>
              <div className={isPosUser ? "product-name-pos" : "product-name"}>
                {props.size}
              </div>
            </div>
            <div className="mt-2 d-flex justify-content-center align-self-stretch product-info-section">
              {props.productInformation && props.productInformation.trim() !== '' && (
                <span 
                  className="product-info-link"
                  onClick={handleShowModal}
                >
                  Product Information
                </span>
              )}
            </div>
            <div className="price">
              {props.price}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function quantityInfo(){

    if (productIsOutOfStock || stockQuantity == 0) {
      return outOfStock();
    } else {
      return maxQuantityPerOrderMessage();
    }

  }

  const maxQuantityPerOrderMessage = () => (
    <div className="product-max-quantity">
      Max quantity: <span className={(increaseDisabled === true) ? 'red' : ''}>{maxPerOrder}</span>
    </div>
  )

  const outOfStock = () => (
    <div className="product-max-quantity">
      Quantity remaining in stock: <span className='red'>{stockQuantity}</span>
    </div>
  )

    const ProductInformationModal = () => (
      <div className={`product-info-modal ${showModal ? 'd-block' : 'd-none'}`}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Product Information</h5>
              <button type="button" className="close" onClick={handleCloseModal}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div dangerouslySetInnerHTML={{__html: props.productInformation}} />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
      <div className="card product-card text-center mb-4" id={props.productAnchorText}>
        <div className="d-flex flex-column align-items-end card-body" style={isPosUser ? {justifyContent: 'center'} : {}}  >
          {productInfoFull()}
          {props.maxQuantityPerOrder === 0 && (
            <div className="product-not-available">Sold Out</div>
          ) || (
            <button onClick={(e) => props.handleAddToCart(props.id, 1, props.currentOrderId)} className={addButtonClass}>
              {(props.itemType == "foodTable") && "Add To Table" || "Add To Cart"}
            </button>
          )}
        </div>

        <CSSTransition
          in={active}
          timeout={300}
          className={transitionClassName}
          classNames="product-card-transition"
          unmountOnExit
        >
          <div>
            {productInfoCondensed(isPosUser)}
            <div className="container-fluid">
              {(displayQuantityLimitMessage) && (
                quantityInfo()
              ) || (<div className="vertical-placeholder"></div>)}
              <div className="d-flex justify-content-center align-items-center">
                <div className="text-right">
                  <a className="btn btn-primary btn-circle" onClick={decreaseQuantity}><i className="fa fa-minus"></i></a>
                </div>
                <div className="">
                  <input type="number" maxLength="3" pattern="\d*" className={"form-control" + (increaseDisabled===true ? ' red' : '')} onBlur={handleQuantityOnBlur} onChange={(e) => updateQuantity(e.target.value)} value={quantity} />
                </div>
                <div className="text-left">
                  <a className="btn btn-primary btn-circle" onClick={increaseQuantity}><i className="fa fa-plus"></i></a>
                </div>
              </div>
              <div className="product-subtotal">
                Subtotal: <span>{orderDetail.total || "$0.00"}</span>
              </div>
              <div className="product-remove">
                <a onClick={(e) => updateQuantity(0)}>
                  {(props.itemType == "foodTable") && "Remove From Table" || "Remove From Cart"}
                </a>
              </div>
            </div>
          </div>
        </CSSTransition>

      </div>
        {showModal && <ProductInformationModal />}
    </div>
  );
}
